import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import UttamKalakarHeader from './UttamKalakarHeader';
import UttamKalakarFooter from './UttamKalakarFooter';

function ArticleImageUpload() {

    const [images, setImages] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);

    const userId = sessionStorage.getItem('userId');

    useEffect(() => {
        fetchUploadedImages();
    }, [userId]);

    const fetchUploadedImages = () => {
        axios.get(`https://nrdruhs.in/upload/displayimages?userId=${userId}`)
            .then(res => setUploadedImages(res.data))
            .catch(err => console.error(err));
    };

    // ✅ Select images (NO LIMIT)
    const handleImageSelect = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        if (!/\.(jpe?g)$/i.test(file.name)) {
            Swal.fire('Invalid file type', 'Only JPG/JPEG images allowed.', 'error');
            return;
        }

        if (file.size > 1 * 1024 * 1024) {
            Swal.fire('File too large', 'Image must be less than 1 MB.', 'error');
            return;
        }

        setImages([file]); // only ONE file
    };


    // ✅ Upload images
    const handleImageUpload = () => {

        if (images.length === 0) {
            Swal.fire('Error', 'Please select images first', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('userId', userId);

        images.forEach(img => {
            formData.append('images', img);
        });

        axios.post('https://nrdruhs.in/upload/images', formData)
            .then(() => {
                Swal.fire('Success', 'Images uploaded successfully', 'success');
                setImages([]);
                fetchUploadedImages();
            })
            .catch(() => {
                Swal.fire('Error', 'Upload failed', 'error');
            });
    };

    // ✅ Delete image
    const handleDeleteImage = (id) => {
        axios.post(`https://nrdruhs.in/upload/deleteimage/${id}`)
            .then(() => {
                Swal.fire('Deleted', 'Image removed', 'success');
                fetchUploadedImages();
            })
            .catch(() => {
                Swal.fire('Error', 'Delete failed', 'error');
            });
    };

    // ✅ SAVE BUTTON (clears UI only)
    const handleSaveImages = async () => {

        if (uploadedImages.length === 0) {
            Swal.fire('No Images', 'Nothing to save!', 'info');
            return;
        }

        console.log("Sending userId:", userId); // 👈 DEBUG

        try {
            const res = await axios.post(
                'https://nrdruhs.in/upload/markSaved',
                { userId: userId }
            );

            console.log("API RESPONSE:", res.data); // 👈 DEBUG

            setUploadedImages([]);
            setImages([]);

            Swal.fire('Success', 'Your images saved successfully!', 'success');

        } catch (error) {
            console.error("SAVE ERROR:", error);
            Swal.fire('Error', 'Failed to save images', 'error');
        }
    };

    return (
        <div>
            <UttamKalakarHeader />

            <div className="container" style={{ paddingTop: 40, paddingBottom: 40 }}>

                <h3 style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    background: '#ff2056',
                    color: '#fff',
                    padding: 15
                }}>
                    Step 2: Upload Images
                </h3>

                <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}> Note: the size of the images should not be more than 1 MB. </h5>

                {/* Upload Box */}
                <div className="card mt-4" style={{ background: '#dfdfdf' }}>
                    <div className="card-body text-center">

                        <input
                            type="file"
                            accept=".jpg,.jpeg"
                            onChange={handleImageSelect}
                            className="form-control"
                        />

                        {images.length > 0 && (
                            <ul className="mt-2">
                                {images.map((img, i) => (
                                    <li key={i}>{img.name}</li>
                                ))}
                            </ul>
                        )}

                        <button
                            className="btn btn-primary mt-3"
                            onClick={handleImageUpload}
                        >
                            Upload Images
                        </button>

                        <p style={{ color: 'grey', marginTop: 10, textAlign: 'center' }}>
                            Max size: 1MB (JPG/JPEG only)
                        </p>

                        {/* Uploaded Images */}
                        {uploadedImages.length > 0 && (
                            <div className="mt-4">

                                <h6>Uploaded Images</h6>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, 160px)',
                                    gap: 15,
                                    justifyContent: 'center'
                                }}>
                                    {uploadedImages.map(img => (
                                        <div key={img.id} style={{
                                            background: '#fff',
                                            borderRadius: 10,
                                            overflow: 'hidden'
                                        }}>

                                            <div style={{
                                                height: 150,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                background: '#f5f5f5'
                                            }}>
                                                <img
                                                    src={`https://nrdruhs.in/uploads/images/${img.fileName}`}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        objectFit: 'contain'
                                                    }}
                                                    alt=""
                                                />
                                            </div>

                                            <div style={{ textAlign: 'center', padding: 8 }}>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDeleteImage(img.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* SAVE BUTTON (always visible if images exist) */}
                        {uploadedImages.length > 0 && (
                            <div className="text-center mt-4">
                                <button
                                    className="btn btn-success"
                                    onClick={handleSaveImages}
                                    style={{ padding: '10px 30px', fontWeight: 'bold' }}
                                >
                                    SAVE IMAGES
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <UttamKalakarFooter />
        </div>
    );
}

export default ArticleImageUpload;